import axiosClient from '@/shared/axios';
import { BANNER, BOWLING_CENTERS } from '@/shared/constants/endpoints';

export const getBanner = () => axiosClient.get(BANNER);

export const getAllBowlingCenters = (params) =>
  axiosClient.get(BOWLING_CENTERS.ALL, { params });

export const getBowlingCenter = (uuid) =>
  axiosClient.get(BOWLING_CENTERS.SINGLE.replace(':uuid', uuid));
